module.exports = __webpack_public_path__ + "static/img/logo70.f4b0556.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo70.png
// module id = qHRw
// module chunks = 1